import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardDaysStore } from '../../../../models/useDashboardDaysModel';
import { useDashboardServicesStore } from '../../../../models/useDashboardServicesModel';
import { ServiceNameEnum } from '../../../../types';
import { DashboardPeriod } from '../../../../types/dashboard';
import {
  formatTableServices,
  sortTableDataByService,
} from '../../../../utils/table';
import Percent from '../../Charts/Percent';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import { ScamData, ScamWidgetId } from './type';

const serviceEnabled = [
  ServiceNameEnum.Exchange,
  ServiceNameEnum.ExchangeInline,
  ServiceNameEnum.Gmail,
  ServiceNameEnum.GmailInline,
];

const ScamOverallWidget = ({
  data: { summaryScam, summaryScamPrevious },
}: {
  data: Pick<
    ScamData,
    ScamWidgetId.SummaryScam | ScamWidgetId.SummaryScamPrevious
  >;
}) => {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();
  const {
    days: { DashboardScam: day },
  } = useDashboardDaysStore();

  const config = [
    { width: '20%', grow: 2, align: 'left', tooltip: true },
    { width: '12%', grow: 1, align: 'right' },
    { width: '12%', grow: 1, align: 'right' },
    { width: '10%', grow: 1, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.service'),
    t(`dashboard.chart.column.last${day}`),
    t(`dashboard.chart.column.prev${day}`),
    t('dashboard.chart.column.change'),
  ];

  const rawData = formatTableServices(
    summaryScam[day as DashboardPeriod],
    summaryScamPrevious[day as DashboardPeriod],
    serviceEnabled.reduce(
      (acc, cur) => ((acc[cur] = servicesModel.services[cur] ?? false), acc),
      {} as Record<string, boolean>
    )
  );

  const tableData = sortTableDataByService(rawData).map((row) => [
    t(`common.service.${row[0]}`),
    row[1],
    row[2],
    <Percent n={row[row.length - 1]} />,
  ]);

  return (
    <DashboardCard
      title={t('dashboard.chart.title.scamOverall')}
      iconContent={t('dashboard.chart.desc.scamOverall')}
    >
      <TableTemplate config={config} header={header} data={tableData} />
    </DashboardCard>
  );
};

export const ScamOverall = React.memo(ScamOverallWidget);
